import gsap from "gsap";

import { refreshScrollTriggers } from "./on-scroll-animations";

const toggleAccordion = (accordion, action) => {
  let button = accordion.querySelector(".js-accordion-button");
  let content = accordion.querySelector(".js-accordion-content");
  let innerContent = accordion.querySelector(".js-accordion-inner-content");

  let setOpen = action === "open";

  accordion.classList.toggle("js-accordion--open", setOpen);

  button.setAttribute("aria-expanded", setOpen ? true : false);
  content.setAttribute("aria-hidden", setOpen ? false : true);

  gsap.to(content, {
    height: setOpen ? "auto" : 0,
    duration: 0.3,
    onStart: () => {
      gsap.to(innerContent, {
        opacity: setOpen ? 1 : 0,
        y: setOpen ? 0 : "0.5rem",
        delay: setOpen ? 0.15 : 0,
      });
    },
    onComplete: () => {
      refreshScrollTriggers();
    },
  });
};

export const initAccordions = (el) => {
  const handleClick = (target) => {
    let accordion = target.closest(".js-accordion");

    let isOpen = target.getAttribute("aria-expanded");

    let accordions = target.closest(".accordion-group") || el;

    if (isOpen != "false") {
      toggleAccordion(accordion, "close");
    } else {
      accordions.querySelectorAll(".js-accordion--open").forEach((item) => {
        toggleAccordion(item, "close");
      });

      toggleAccordion(accordion, "open");
    }
  };

  el.querySelectorAll(".js-accordion-button").forEach((button) => {
    button.addEventListener("click", (e) => {
      handleClick(button);
    });
  });
};
